export class Utils {
  // Groups a flat array into a tree.
  // "data" is the flat array.
  // "keys" is an array of properties to group on.
  static groupBy(data, keys): any {
    if (keys.length === 0) {
      return data;
    }
    // The current key to perform the grouping on:
    const key = keys[0];
    // Loop through the data and construct buckets for
    // all of the unique keys:
    const groups = {};
    for (const row of data) {
      const groupValue = row[key];
      if (groups[groupValue] === undefined) {
        groups[groupValue] = new Array();
      }
      groups[groupValue].push(row);
    }
    // Remove the first element from the groups array:
    keys.reverse();
    keys.pop();
    keys.reverse();
    // If there are no more keys left, we're done:
    if (keys.length === 0) {
      return groups;
    }
    // Otherwise, handle further groupings:
    for (const group of Object.keys(groups)) {
      groups[group] = this.groupBy(groups[group], keys.slice());
    }
    return groups;
  }

  static createProperDate(someWeirdDate: Date): Date {
    return new Date((someWeirdDate as unknown) as string);
  }

  static addDays(date: Date, days: number): Date {
    return new Date(date.getTime() + days * (1000 * 60 * 60 * 24));
  }

  static getISODay(date: Date): string {
    return date.toISOString().slice(0, 10);
  }


}
